import { render, staticRenderFns } from "./statsWidget.vue?vue&type=template&id=2f47ce7a&"
import script from "./statsWidget.vue?vue&type=script&lang=js&"
export * from "./statsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports